export default function TaskLoading() {
  return (
    <div className="m-0 py-2 flex items-center gap-2 relative group">
      <div className="bg-white/08 skeleton rounded-full w-9 h-9 flex-center shrink-0"></div>
      <div className="w-full flex gap-1.5 flex-col">
        <h2 className="w-[90%] rounded-md h-3 skeleton"></h2>
        <p className="rounded-md w-[40%] h-2.5 skeleton  font-normal "></p>
      </div>
      <div className="w-[100px] shrink-0 rounded-full skeleton h-[28px]"></div>
      <hr className="absolute bottom-0 left-[45px] translate-y-[0.5px] border-none h-px w-full bg-white/08 group-last:hidden" />
    </div>
  );
}
